export default "__VITE_ASSET__BOxweOpc__"